// average reading speed is 220 words per minute https://irisreading.com/what-is-the-average-reading-speed/
export const readingTimeCalculator = (wordCount = 0, wpm = 220) => {
  const timeToRead = Math.ceil(wordCount / wpm);
  if (timeToRead <= 1) return 1;
  return timeToRead;
};
